"use client";

import { c as _c } from "react/compiler-runtime";
import { SiModelcontextprotocol, SiRaycast } from "@icons-pack/react-simple-icons";
import { IconBookmark, IconBookmarks, IconBrandApple, IconCookie, IconCornerLeftUp, IconExternalLink, IconGavel, IconHeart, IconLifebuoy, IconPuzzle, IconWorld } from "@tabler/icons-react";
import Link from "next/link";
import { useState } from "react";
import { toast } from "sonner";
import { BetaBadge } from "@/components/beta-badge";
import { APPLE_SHORTCUT_ID } from "@domainstack/constants";
import { Button } from "@domainstack/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@domainstack/ui/dialog";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@domainstack/ui/dropdown-menu";

// a little hack to "unsafely" use raw javascript as a link
function hrefScript(element: HTMLAnchorElement | null) {
  if (!element) return;
  element.href = `javascript:(function(){var t=window.open("${process.env.NEXT_PUBLIC_BASE_URL}/"+location.hostname,"_blank");t.focus()})();`;
}
function handleInspectDomainClick(e: React.MouseEvent) {
  e.preventDefault();
  toast.info("Drag the button to your bookmarks bar to use it.", {
    icon: <IconCornerLeftUp className="size-4" />,
    position: "top-center"
  });
}
export function AppFooter() {
  const $ = _c(19);
  const [isBookmarkletsOpen, setIsBookmarkletsOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = open => {
      setIsBookmarkletsOpen(open);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleBookmarkletsOpenChange = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link href="/help"><IconLifebuoy className="text-muted-foreground" />Help</Link>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconPuzzle className="size-4 px-[1px] text-muted-foreground" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DropdownMenuTrigger className="inline-flex cursor-pointer items-center gap-1 text-foreground/85 hover:text-foreground/60">{t2}Integrations<BetaBadge className="ml-[1px] px-1.5 py-0 text-[11px] tracking-normal" /></DropdownMenuTrigger>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DropdownMenuItem nativeButton={false} className="px-1.5 py-1 text-[13px]" render={<Link href="/mcp"><SiModelcontextprotocol className="text-muted-foreground" />MCP Server</Link>} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DropdownMenuItem nativeButton={false} className="px-1.5 py-1 text-[13px]" onClick={() => setIsBookmarkletsOpen(true)}><IconBookmarks className="text-muted-foreground" />Bookmarklet</DropdownMenuItem>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconBrandApple className="text-muted-foreground" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <DropdownMenuItem nativeButton={false} className="px-1.5 py-1 text-[13px]" render={<a href={`workflow://shortcuts/${APPLE_SHORTCUT_ID}`} data-disable-progress={true}>{t6}Shortcut<IconExternalLink className="ml-auto size-3.5 translate-y-[-1px] text-muted-foreground" /></a>} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SiRaycast className="text-muted-foreground" />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <DropdownMenu>{t3}<DropdownMenuContent align="center" sideOffset={8} className="min-w-44 bg-background ring-0">{t4}{t5}{t7}<DropdownMenuItem nativeButton={false} className="px-1.5 py-1 text-[13px]" render={<span>{t8}Raycast (soon)<IconExternalLink className="ml-auto size-3.5 translate-y-[-1px] text-muted-foreground" /></span>} disabled={true} /></DropdownMenuContent></DropdownMenu>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Link href="/terms"><IconGavel className="text-muted-foreground" />Terms</Link>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex flex-wrap items-center justify-center space-x-[1.25em] gap-y-2 [&_a]:whitespace-nowrap">{t1}{t9}{t10}<Link href="/privacy"><IconCookie className="text-muted-foreground" />Privacy</Link></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="inline-flex translate-y-[3px] animate-heartbeat motion-reduce:animate-none"><IconHeart className="fill-destructive stroke-destructive" /></div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <footer className="space-y-1.5 px-4 pt-6 pb-[calc(1rem+env(safe-area-inset-bottom))] text-center text-xs leading-relaxed text-muted-foreground sm:px-6 [&_a]:inline-flex [&_a]:items-center [&_a]:gap-1 [&_a]:text-foreground/85 [&_a]:hover:text-foreground/60 [&_a]:hover:no-underline [&_svg]:inline-block [&_svg]:size-4 [&_svg]:px-[1px]">{t11}<div>Made with{" "}{t12}{" "}by{" "}<a href="https://jarv.is/" target="_blank" rel="noopener">@jakejarvis</a></div></footer>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  let t15;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <DialogHeader><DialogTitle className="flex items-center gap-1.5 text-base font-medium tracking-tight"><IconBookmark className="size-4 text-muted-foreground" />Bookmarklet</DialogTitle></DialogHeader>;
    t15 = <p className="text-sm text-muted-foreground">Drag the button below to your bookmarks bar. Then, press it on any site and the report for that domain will open in a new tab, like magic!</p>;
    $[14] = t14;
    $[15] = t15;
  } else {
    t14 = $[14];
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <DialogContent className="!max-w-lg">{t14}{t15}<div className="my-2 flex justify-center"><Button size="lg" nativeButton={false} aria-label="Inspect Domain" render={<a ref={hrefScript} href="#"><IconWorld />Inspect Domain</a>} onClick={handleInspectDomainClick} /></div></DialogContent>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] !== isBookmarkletsOpen) {
    t17 = <>{t13}<Dialog open={isBookmarkletsOpen} onOpenChange={handleBookmarkletsOpenChange}>{t16}</Dialog></>;
    $[17] = isBookmarkletsOpen;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  return t17;
}